import React from "react";

const NotInOrganization = () => {
	return (
		<div>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
					width: "100vw",
				}}
			>
				<img
					src="/R-gradient.png"
					alt="loading..."
					style={{
						width: "100px",
						height: "auto",
						animation: "pulseAndFade 1.5s ease-in-out infinite",
					}}
				/>
			</div>
		</div>
	);
};

export default NotInOrganization;
